import { useSearchParams } from "react-router-dom"
import { readLandingLanguage } from "./landingLanguage"

export function useLandingLanguage() {
  const [searchParams] = useSearchParams()
  return readLandingLanguage(searchParams)
}
